import Image from 'next/image';
import { imageSerializer } from '../../../../utils/imageSerializer';
import { IProcessItem } from './interfaces';
import {
  Divider,
  ItemDescription,
  ProcessItemWrapper,
} from './processItem.styles';

export const ProcessItem = ({
  title,
  image,
  description,
  index,
  itemsLength,
}: IProcessItem) => {
  return (
    <>
      <ProcessItemWrapper>
        <Image {...imageSerializer(image)} />
        <ItemDescription>{description}</ItemDescription>
      </ProcessItemWrapper>
      {index < itemsLength - 1 && (
        <Divider>
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.79688 18.5L15.7969 12.5L9.79688 6.5"
              stroke="#667070"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </Divider>
      )}
    </>
  );
};
